
import { ref, computed, defineComponent } from "vue-demi";
import { SMNotifications } from "@/store";
import notificationBell from "@/modules/Notifications/icons/notification.svg";
import notificationBellFilled from "@/modules/Notifications/icons/notification-filled.svg";

export default defineComponent({
  name: "NotificationsModule",

  components: {
    NotificationsPopover: () =>
      import("@/modules/Notifications/NotificationsPopover/NotificationsPopover.vue"),
    Toast: () => import("@/modules/Notifications/NotificationsPopover/Toast.vue"),
  },

  setup() {
    const isPopoverOpen = ref(false);

    function closePopover() {
      isPopoverOpen.value = false;
    }

    const isToastOpen = ref(true);

    function onToastCancel() {
      isToastOpen.value = false;
    }

    const imageSrc = computed(() => {
      if (SMNotifications.hasNotifications) return notificationBellFilled;

      return notificationBell;
    });

    const bellRef = ref<HTMLElement | null>(null);
    const popoverPosition = ref({ top: 0, right: 24 });

    function openPopover() {
      if (bellRef.value) {
        const rect = bellRef.value.getBoundingClientRect();
        popoverPosition.value = {
          top: rect.bottom + 12, // 12px below bell
          right: 24,
        };
      }

      isPopoverOpen.value = true;
    }

    return {
      imageSrc,
      isPopoverOpen,
      openPopover,
      closePopover,
      isToastOpen,
      onToastCancel,
      popoverPosition,
      bellRef,
    };
  },
});
